import React from "react";
import { cn } from "../../lib/helpers";

const LOGOS = [
  {
    label: "Full Logo — White",
    preview: "/img/logos/common-room-logo-white.svg",
    files: [
      { ext: "SVG", path: "/img/logos/common-room-logo-white.svg" },
      { ext: "PNG", path: "/img/logos/common-room-logo-white.png" },
    ],
    isDark: true,
    height: 10,
  },
  {
    label: "Full Logo",
    preview: "/img/logos/common-room-logo-color.svg",
    files: [
      { ext: "SVG", path: "/img/logos/common-room-logo-color.svg" },
      { ext: "PNG", path: "/img/logos/common-room-logo-color.png" },
    ],
    height: 10,
  },
  {
    label: "Full Logo — Light",
    preview: "/img/logos/common-room-logo-light.svg",
    files: [
      { ext: "SVG", path: "/img/logos/common-room-logo-light.svg" },
      { ext: "PNG", path: "/img/logos/common-room-logo-light.png" },
    ],
    isDark: true,
    height: 10,
  },
  {
    label: "Logo Mark",
    preview: "/static/meta/common-room-logo.svg",
    files: [
      { ext: "SVG", path: "/static/meta/common-room-logo.svg" },
      { ext: "PNG", path: "/static/meta/common-room-logo.png" },
    ],
  },
  {
    label: "Logo Mark — White",
    preview: "/static/meta/common-room-logo-white.svg",
    files: [
      { ext: "SVG", path: "/static/meta/common-room-logo-white.svg" },
      { ext: "PNG", path: "/static/meta/common-room-logo-white.png" },
    ],
    isDark: true,
  },
];

export const BrandDownloads = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
    {LOGOS.map(({ label, description, preview, files, isDark, height }) => (
      <div
        key={label}
        className={cn(
          "flex flex-col justify-between rounded-xl border overflow-hidden transition-colors duration-200",
          isDark ? "bg-dark-80" : "border-black"
        )}
      >
        <div className="flex items-center justify-center p-8 pb-4">
          <img
            src={preview}
            alt={label}
            className={cn("w-auto", `max-h-${height || 12}`)}
          />
        </div>
        <div className="p-3 pt-0 text-lg font-medium">
          <div className="flex gap-3">
            {files.map(({ ext, path }) => (
              <a
                key={ext}
                href={path}
                download
                className={cn(
                  "flex-1 text-center py-3 px-4 transition-colors duration-200 rounded-lg",
                  isDark ? "hover:bg-dark-70 text-white" : "hover:bg-dark-5"
                )}
              >
                Download {ext}
              </a>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);
